<template>
     <section id="team" class="team_area pt-120 pb-130">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <div class="section_title text-center pb-25">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
            >
              Conheça o Time
            </h4>
            <!--<p
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s"
            >
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt labor dolore.
            </p>-->
          </div>
        </div>
      </div>
      <div class="row justify-content-center team_active">
        <div class="col-lg-4 col-md-8 col-sm-10">
          <div
            class="single_team mt-30 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.2s"
          >
            <img src="assets/images/team/team-1.jpg" alt="team" />
            <div class="team_content">
              <h4 class="team_name"><a href="#">Marcelina Pereira</a></h4>
              <!--<p>Head Of Ideas</p>-->
              <ul class="social">
                <!--<li>
                  <a href="#"><i class="lni lni-facebook-filled"></i></a>
                </li>
                <li>
                  <a href="#"><i class="lni lni-twitter-original"></i></a>
                </li>-->
                <li>
                  <a href="#"><i class="lni lni-linkedin-original"></i></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-10">
          <div
            class="single_team mt-30 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.3s"
          >
            <img src="assets/images/team/team-2.jpg" alt="team" />
            <div class="team_content">
              <h4 class="team_name"><a href="#">Gabrielly Faria</a></h4>
              <!--<p>UX Designer</p>-->
              <ul class="social">
                <!--<li>
                  <a href="#"><i class="lni lni-facebook-filled"></i></a>
                </li>
                <li>
                  <a href="#"><i class="lni lni-twitter-original"></i></a>
                </li>-->
                <li>
                  <a
                    href="https://www.linkedin.com/in/gabrielly-faria-8b78651a3/"
                    target="_blank"
                    ><i class="lni lni-linkedin-original"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-10">
          <div
            class="single_team mt-30 wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.4s"
          >
            <img src="assets/images/team/team-3.jpeg" alt="team" />
            <div class="team_content">
              <h4 class="team_name"><a href="#">Gabriela Silva</a></h4>
              <!--<p>Creative Designer</p>-->
              <ul class="social">
                <!--<li>
                  <a href="#"><i class="lni lni-facebook-filled"></i></a>
                </li>
                <li>
                  <a href="#"><i class="lni lni-twitter-original"></i></a>
                </li>-->
                <li>
                  <a
                    href="https://www.linkedin.com/in/gabrielapereiradasilva/"
                    target="_blank"
                    ><i class="lni lni-linkedin-original"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  //props: ['textconteudo', 'icon', 'title'],
};
</script>

<style scoped>

</style>